// ── Environment configuration map ─────────────────────────────────────────
// Keyed by environment name: 'localhost' | 'dev' | 'stage' | 'prod'
// Environment is read from window.cdcext.customEnvironment at runtime.
const config_map = new Map();

config_map.set('localhost', {
  video_base_url:  'http://cdam-amd-dev-01:9090/adaptivemedia/rendition?id=',
  vtt_base_url:    'http://cdam-amd-dev-01:9090/adaptivemedia/transcript?id=',
  okta_issuer:     'https://int-id.cisco.com',
  client_id:       '900461b2-2215-4c25-87a8-bb8355086767',
  restapi_base_url: ''   // empty → relative → Vite proxy forwards to localhost:8080
});

config_map.set('dev', {
  video_base_url:  'https://cxassets-dev.cisco.com/adaptivemedia/rendition?id=',
  vtt_base_url:    'https://salesassets-dev.cisco.com/adaptivemedia/transcript?id=',
  chapter_url:     'https://salesassets-dev.cisco.com/adaptivemedia',
  okta_issuer:     'https://int-id.cisco.com',
  client_id:       '900461b2-2215-4c25-87a8-bb8355086767',
  restapi_base_url: 'https://cdam-devvp.cisco.com'
});

config_map.set('stage', {
  video_base_url:  'https://cdampubdelivery-stg.cisco.com/adaptivemedia/rendition?id=',
  vtt_base_url:    'https://cdampubdelivery-stg.cisco.com/adaptivemedia/transcript?id=',
  chapter_url:     'https://cdampubdelivery-stg.cisco.com/adaptivemedia',
  okta_issuer:     'https://int-id.cisco.com',
  client_id:       '62f0398d-f5e3-4ad6-8751-cc4c2e94c2bb',
  restapi_base_url: 'https://cdam-stagevp.cisco.com'
});

config_map.set('prod', {
  video_base_url:  'https://cdampubdelivery.cisco.com/adaptivemedia/rendition?id=',
  vtt_base_url:    'https://cdampubdelivery.cisco.com/adaptivemedia/transcript?id=',
  chapter_url:     'https://cdampubdelivery.cisco.com/adaptivemedia',
  okta_issuer:     'https://id.cisco.com',
  client_id:       'f3317670-d369-410a-a8b0-1c94b5deee34',
  // Explicit origin: cdam-vp.cisco.com is a CDN — POST requests must bypass it
  restapi_base_url: 'https://cdam-prodvp-origin.cisco.com'
});

// ── ConfigManager ──────────────────────────────────────────────────────────

export class ConfigManager {
  /**
   * Returns the config for the given environment string.
   * Expected values: 'dev' | 'stage' | 'prod'
   * Anything else (including undefined/null) falls back to 'localhost'.
   */
  static retrieveConfig(environment) {
    const config = config_map.get(environment);
    if (!config) {
      console.warn(`ConfigManager: unknown environment "${environment}" — falling back to localhost config.`);
      return config_map.get('localhost');
    }
    return config;
  }
}
